import { sortChatMessages } from './sortMessages';

export const buildTrajectory = (chatMetadata, messages, rationale) => {
  const fromMetadata = chatMetadata?.trajectory?.message_valences;
  const fromRationale = rationale?.trajectory?.message_valences;
  const sourceMessageValences =
    Array.isArray(fromMetadata) && fromMetadata.length > 0
      ? fromMetadata
      : (Array.isArray(fromRationale) ? fromRationale : []);

  let messageValences = [];
  if (sourceMessageValences.length > 0) {
    messageValences = sourceMessageValences
      .map((mv, idx) => ({
        turn_id: mv.turn_id != null ? mv.turn_id : idx + 1,
        role: mv.role || 'unknown',
        valence: typeof mv.valence === 'number' ? mv.valence : parseFloat(mv.valence)
      }))
      .filter((point) => !Number.isNaN(point.valence))
      .sort((a, b) => a.turn_id - b.turn_id);
  } else if (Array.isArray(messages) && messages.length > 0) {
    messageValences = sortChatMessages(messages)
      .map((message, idx) => ({
        turn_id: message.order != null ? message.order : idx + 1,
        role: message.role || message.sender || 'unknown',
        valence: typeof message.valence === 'number' ? message.valence : parseFloat(message.valence)
      }))
      .filter((point) => !Number.isNaN(point.valence))
      .sort((a, b) => a.turn_id - b.turn_id);
  }

  const opening =
    chatMetadata?.trajectory?.opening_valence ??
    rationale?.trajectory?.opening_valence ??
    chatMetadata?.opening_valence ??
    null;
  const closing =
    chatMetadata?.trajectory?.closing_valence ??
    rationale?.trajectory?.closing_valence ??
    chatMetadata?.closing_valence ??
    null;
  const delta =
    chatMetadata?.trajectory?.delta_open_to_close ??
    rationale?.trajectory?.delta_open_to_close ??
    chatMetadata?.delta_open_to_close ??
    chatMetadata?.delta_valence ??
    null;

  return {
    message_valences: messageValences,
    opening_valence: opening != null ? parseFloat(opening) : null,
    closing_valence: closing != null ? parseFloat(closing) : null,
    delta_open_to_close: delta != null ? parseFloat(delta) : null
  };
};
